import { useState } from 'react';
import { Alert, Box, Button, Container, Link, Paper, Stack, TextField, Typography } from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Link as RouterLink } from 'react-router-dom';
import { z } from 'zod';
import { apiClient } from '../../lib/api-client';

const schema = z.object({
  email: z.string().email("Adresse e-mail invalide"),
});

type FormValues = z.infer<typeof schema>;

export function ForgotPasswordPage() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({ resolver: zodResolver(schema) });

  const onSubmit = handleSubmit(async (values) => {
    setSubmitting(true);
    try {
      await apiClient.post('/v1/auth/forgot-password', values);
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  });

  return (
    <Container maxWidth="sm">
      <Box component="main" sx={{ py: 8 }}>
        <Paper elevation={1} sx={{ p: 4 }}>
          <Typography component="h1" variant="h5" gutterBottom>
            Mot de passe oublié
          </Typography>

          {submitted ? (
            <Alert severity="success" sx={{ mt: 2 }}>
              Si un compte est associé à cette adresse, un lien de réinitialisation vient
              d&apos;être envoyé. Vérifiez votre boîte de réception.
            </Alert>
          ) : (
            <form onSubmit={onSubmit} noValidate>
              <Stack spacing={2} sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  Indiquez votre adresse e-mail, nous vous enverrons un lien de réinitialisation
                  valable 30 minutes.
                </Typography>
                <TextField
                  {...register('email')}
                  label="Adresse e-mail"
                  type="email"
                  autoComplete="email"
                  required
                  error={Boolean(errors.email)}
                  helperText={errors.email?.message}
                />
                <Button type="submit" variant="contained" size="large" disabled={submitting}>
                  {submitting ? 'Envoi…' : 'Envoyer le lien'}
                </Button>
                <Link component={RouterLink} to="/login" underline="hover">
                  Retour à la connexion
                </Link>
              </Stack>
            </form>
          )}
        </Paper>
      </Box>
    </Container>
  );
}
